import { Outlet, useLocation } from 'react-router-dom'

import { observer } from 'mobx-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'
import { useSettings } from 'modules/settings/hooks/useSettings'
import CollectionsBootstrap from 'modules/settings/lib/CollectionsBootstrap'
import { canAccessSettings } from 'modules/settings/lib/settings'

const Container = observer(() => {
  const { navigation } = useNavigation()
  const { pathname } = useLocation()
  const { settings, settingsChildren, loading, seeAllSettingsPages } = useSettings()
  const { employee } = useCurrentSession()
  const setting = settingsChildren.find((item) => pathname.startsWith(item.url))

  useEffect(() => {
    const settingPage = settingsChildren.find((item) => item.url === pathname)

    if (settingPage) {
      track(trackingEvents.settings.visitDetail, {
        setting_category: settingPage.category,
        setting_name: settingPage.id,
      })
    }
  }, [])

  const canAccessSettingPage = () => {
    if (navigation.settings.fullPath() === pathname) {
      return canAccessSettings(settings)
    }

    if (setting) {
      return setting.filter?.() ?? true
    }

    return seeAllSettingsPages
  }

  const authorizeFn = () => hasRegularAccessOrNotEmployee(employee) && !!canAccessSettingPage()

  if (loading) return <Loading />

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <Outlet />
    </AuthorizeUser>
  )
})

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
